import { motion } from "framer-motion";
import { Spinner } from "./spinner";
import { useId } from "react";

export type ComponentSpinnerProps = {
  size?: string
}

const ComponentSpinner = ({ size }: ComponentSpinnerProps) => {
  const uuid = useId();

  return (<motion.div
    key={uuid}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="flex items-center justify-center w-full h-full self-stretch">
    <Spinner size={size || "10%"} />
  </motion.div>)
}

export default ComponentSpinner;
